import {Vector2} from "../models/math.model";
import NumberInput from "./numberInput.element";
import {useState} from "react";
import {Tooltip} from "@mui/material";
import {useFieldDoc} from "./useFieldDoc";

interface Vector2InputProps {
    // Optional: omitted when `field` supplies the label from the model's [FieldDoc].
    title?: string;
    value: Vector2;
    tooltip?: string;
    // Manifest field key — sources the label + tooltip from the Client model.
    field?: string;
    onChange(value: Vector2): void;
}

function Vector2Input(props: Vector2InputProps) {
    const {label, tip} = useFieldDoc({field: props.field, title: props.title, tooltip: props.tooltip});
    const [x, setX] = useState<number>(props.value.x);
    const [y, setY] = useState<number>(props.value.y);

    function changeX(value: number) {
        setX(value);
        props.onChange({x: value, y: y});
    }

    function changeY(value: number) {
        setY(value);
        props.onChange({x: x, y: value});
    }

    return (
        <div className={'layout horizontal stretch gap'} style={{alignItems: 'center', gap: 10}}>
            {tip
                ? <Tooltip title={tip} arrow disableInteractive>
                    <p style={{cursor: 'help'}}>{label}</p>
                </Tooltip>
                : <p>{label}</p>}
            <div className={'layout horizontal gap'}>
                <NumberInput style={{width: 60}} step={'0.01'} displayDecimals={3} value={x} onChange={changeX}/>
                <NumberInput style={{width: 60}} step={'0.01'} displayDecimals={3} value={y} onChange={changeY}/>
            </div>
        </div>
    )
}

export default Vector2Input;